import { Form } from "react-router-dom"
import { user } from "../../backoffice/dtos/authentication/user"
import { Promotion } from "../../backoffice/dtos/promotions/promotion"
import { Col, Container, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useMemo } from "react"
import { PromotionInfo } from "../../backoffice/dtos/promotions/PromotionInfo"
import { useTranslation } from "react-i18next"
import { PromotionProductInfo } from "../../backoffice/dtos/promotions/PromotionProductInfo"

const colors = ["#00AA00", "#55FF55", "#FF3333"];
const labels = ["Created", "Updated", "Deleted"];

export default function PromotionInfoComponent(
    {
        headerKey,
        user,
        promotion,
        promotionInfo,
        toggle,
    }: {
        headerKey: string
        user: user | undefined
        promotion: Promotion
        promotionInfo: PromotionInfo;
        toggle: () => void
    }
) {
    const {t} = useTranslation(['promotion_timeline','common','promotion'])

    const color = useMemo(() => {
        return colors[promotionInfo.state];
    }, [promotionInfo.state]);

    const text = useMemo(() => {
        return labels[promotionInfo.state];
    }, [promotionInfo.state]);
    return (
        <Container>
            <h4 className="mt-3">{t('Promotion')}</h4>
            <hr/>
            {
                promotionInfo.error && (
                    <Row className="gy-2 p-2">
                        <Col lg={12}>
                            <InputGroup>
                                <InputGroupText style={{ backgroundColor: "red", color: "white" }} >
                                    {t("Upload Error")}
                                </InputGroupText>
                                <Input type="text" name='state' value={promotionInfo.error} disabled={true} />
                            </InputGroup>
                        </Col>
                    </Row>
                )
            }
            <Row className="gy-2 p-2">
                <Label for="creationDate" lg={2}>{t('Date')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Creation')} 
                        </InputGroupText>
                        <Input type="text" name='creationDate' value={promotionInfo.creationDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Update')}
                        </InputGroupText>
                        <Input type="text" name='updateDate' value={promotionInfo.updateDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="uploadDate" lg={2}>{t('Upload')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('To Upload')}
                        </InputGroupText>
                        <Input type="text" name='dateAllowedToUpload' value={promotionInfo.dateAllowedToUpload} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText style={{ backgroundColor: promotionInfo.hasBeenUploaded ? "green" : "red", color: "white" }} >
                            {t('Upload')}
                        </InputGroupText>
                        <Input type="text" name='uploadDate' value={promotionInfo.uploadDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Col lg={2}/>
                <Col lg={4}>
                    <InputGroup>
                        <InputGroupText>{t('Retries')}</InputGroupText>
                        <Input type="text" name='uploadRetries' value={promotionInfo.uploadRetries} disabled={true} />
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="properties" lg={2}>{t('Properties')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Purchase Document Type')}
                        </InputGroupText>
                        <Input type="text" name='purchaseDocumentType' value={promotionInfo.purchaseDocumentType} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Purchasing Organization')}
                        </InputGroupText>
                        <Input type="text" name='purchasingOrganization' value={promotionInfo.purchasingOrganization} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Col lg={2}/>
                <Col lg={4}>
                    <InputGroup>
                        <InputGroupText>{t('Purchasing Group')}</InputGroupText>
                        <Input type="text" name='purchasingGroup' value={promotionInfo.purchasingGroup} disabled={true} />
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="state" lg={2}>{t('PO State')}</Label>

                <Col lg={4}>
                    <InputGroup>
                        <InputGroupText style={{ backgroundColor: color, color: "white", width: 40 }} />
                        <Input type="text" name='state' value={text} disabled={true} />
                    </InputGroup>
                </Col>
            </Row>
            {
                promotionInfo.products && (
                    <>
                        <hr className="mt-3"/>
                        <h4>{t('Products')}</h4>
                    </>
                )
            }
            {
                promotionInfo.products && promotionInfo.products.map(m => (
                    <>
                        <hr />
                        <PromotionProductInfoComponent promotionProductInfo={m} />
                    </>
                ))
            }
        </Container>
    );
}

export function PromotionProductInfoComponent(
    {
        promotionProductInfo,
    }: {
        promotionProductInfo: PromotionProductInfo;
    }
) {
    const {t} = useTranslation(['promotion_timeline','common','promotion'])

    const color = useMemo(() => {
        return colors[promotionProductInfo.action];
    }, [promotionProductInfo.action]);

    const text = useMemo(() => {
        return labels[promotionProductInfo.action];
    }, [promotionProductInfo.action]);

    return (
        <>
            {
                promotionProductInfo.error && (
                    <Row className="gy-2 p-2">
                        <Col lg={12}>
                            <InputGroup>
                                <InputGroupText style={{ backgroundColor: "red", color: "white" }} >
                                    {t("Upload Error")}
                                </InputGroupText>
                                <Input type="text" name='state' value={promotionProductInfo.error} disabled={true} />
                            </InputGroup>
                        </Col>
                    </Row>
                )
            }
            <Row className="gy-2 p-2">
                <Label for="name" lg={2}>{t('Name')}</Label>

                <Col lg={10}>
                    <InputGroup>
                        <InputGroupText>
                            {promotionProductInfo.code}
                        </InputGroupText>
                        <Input type="text" name='name' value={promotionProductInfo.name} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="creationDate" lg={2}>{t('Date')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Creation')} 
                        </InputGroupText>
                        <Input type="text" name='creationDate' value={promotionProductInfo.creationDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Update')}
                        </InputGroupText>
                        <Input type="text" name='updateDate' value={promotionProductInfo.modificationDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="uploadDate" lg={2}>{t('Upload')}</Label>

                <Col lg={5}>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText style={{ backgroundColor: promotionProductInfo.uploaded ? "green" : "red", color: "white" }} >
                            {t('Upload')}
                        </InputGroupText>
                        <Input type="text" name='uploadDate' value={promotionProductInfo.uploadDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="properties" lg={2}>{t('Properties')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Order Number')}
                        </InputGroupText>
                        <Input type="text" name='orderNumber' value={promotionProductInfo.orderNumber} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('GL Account')}
                        </InputGroupText>
                        <Input type="text" name='glAccount' value={promotionProductInfo.glAccount} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="state" lg={2}>{t('PO State')}</Label>

                <Col lg={4}>
                    <InputGroup>
                        <InputGroupText style={{ backgroundColor: color, color: "white", width: 40 }} />
                        <Input type="text" name='state' value={text} disabled={true} />
                    </InputGroup>
                </Col>
            </Row>
        </>
    );
}